import styled from 'styled-components'

import theme, { ScreenBreakpoints } from '../../theme'

const StyledMain = styled.div`
  box-sizing: border-box;
  position: fixed;
  top: 18px;
  bottom: 0;
  right: 0;
  width: 230px;
  background-color: ${theme.colors.white};
  z-index: 0;
  border-left: 1px solid ${theme.colors.gray4};

  @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
    width: 420px;
  }

  &.bannerAndHeader {
    box-sizing: border-box;
    position: fixed;
    top: 90px;
    bottom: 0;
    right: 0;
    width: 230px;
    background-color: ${theme.colors.white};
    z-index: 0;
    border-left: 1px solid ${theme.colors.gray4};

    @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
      width: 420px;
    }
  }

  &.globalHeader {
    box-sizing: border-box;
    position: fixed;
    top: 72px;
    bottom: 0;
    right: 0;
    width: 230px;
    background-color: ${theme.colors.white};
    z-index: 0;
    border-left: 1px solid ${theme.colors.gray4};

    @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
      width: 420px;
    }
  }

  &.banner {
    box-sizing: border-box;
    position: fixed;
    top: 18px;
    bottom: 0;
    right: 0;
    width: 230px;
    background-color: ${theme.colors.white};
    z-index: 0;
    border-left: 1px solid ${theme.colors.gray4};

    @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
      width: 420px;
    }
  }

  .header {
    height: 56px;
    background-color: ${theme.colors.gray9};
    color: ${theme.colors.white};
    border-left: 1px solid #2a313a;
    margin-left: -1px;
  }

  .main {
    height: calc(100% - 64px);
    overflow: auto;
    padding-bottom: 24px;

    &.with-footer {
      height: calc(100% - 120px);
      padding-bottom: 24px;
    }
  }

  .footer {
    height: 64px;
    border-top: 1px solid ${theme.colors.gray4};
  }

  .header,
  .main,
  .footer {
    @media (max-width: ${ScreenBreakpoints.large}px) {
      padding: 0 16px;
    }

    @media (min-width: ${ScreenBreakpoints.large + 1}px) and (max-width: ${ScreenBreakpoints.extraLarge}px) {
      padding: 0 16px;
    }

    @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
      padding: 0 24px;
    }
  }
`

export { StyledMain }
